import { all, call, put, takeLatest } from "redux-saga/effects";
import queryApi from "../../utils/fetchApi";
import Urler from "../../utils/serviceUrl";
import {
  fetchAllFixturesFailure,
  fetchAllFixturesSuccess,
  fetchCreatorFixturesFailure,
  fetchCreatorFixturesSuccess,
  fetchTournamentFixturesFailure,
  fetchTournamentFixturesSuccess,
  fetchUserFixturesFailure,
  fetchUserFixturesSuccess,
} from "./fixtures.actions";
import fixturesActionTypes from "./fixtures.types";

const normalizeFixturesResponse = (response) => {
  if (!response) return [];

  if (Array.isArray(response)) {
    return response;
  }

  if (response.data?.fixtures) return response.data.fixtures;
  if (response.data?.data?.fixtures) return response.data.data.fixtures;
  if (response.data?.data) return response.data.data;

  return response.fixtures || response.data || [];
};

function* fetchAllFixtures({ payload: { token } }) {
  try {
    const res = yield queryApi({
      method: "GET",
      url: Urler("/fixtures"),
      bearer: token,
    });

    if (res.status === "Success" || res.status === "success") {
      yield put(fetchAllFixturesSuccess(normalizeFixturesResponse(res)));
    } else {
      yield put(
        fetchAllFixturesFailure(res.message || "Unable to load fixtures"),
      );
    }
  } catch (error) {
    yield put(fetchAllFixturesFailure(error.message));
  }
}

function* fetchUserFixtures({ payload: { token } }) {
  try {
    const res = yield queryApi({
      method: "GET",
      url: Urler("/fixtures/subscriber"),
      bearer: token,
    });

    if (res.status === "Success" || res.status === "success") {
      yield put(fetchUserFixturesSuccess(normalizeFixturesResponse(res)));
    } else {
      yield put(
        fetchUserFixturesFailure(res.message || "Unable to load fixtures"),
      );
    }
  } catch (error) {
    yield put(fetchUserFixturesFailure(error.message));
  }
}

function* fetchCreatorFixtures({ payload: { token, tournamentId } }) {
  try {
    const endpoint = tournamentId
      ? `/tournaments/${tournamentId}/fixtures/creator`
      : "/fixtures/creator";

    const res = yield queryApi({
      method: "GET",
      url: Urler(endpoint),
      bearer: token,
    });

    if (res.status === "Success" || res.status === "success") {
      yield put(fetchCreatorFixturesSuccess(normalizeFixturesResponse(res)));
    } else {
      yield put(
        fetchCreatorFixturesFailure(res.message || "Unable to load fixtures"),
      );
    }
  } catch (error) {
    yield put(fetchCreatorFixturesFailure(error.message));
  }
}

function* fetchTournamentFixtures({
  payload: { token, tournamentId, viewMode },
}) {
  try {
    const mode = viewMode === "creator" ? "creator" : "subscriber";
    const res = yield queryApi({
      method: "GET",
      url: Urler(`/tournaments/${tournamentId}/fixtures/${mode}`),
      bearer: token,
    });

    if (res.status === "Success" || res.status === "success") {
      yield put(
        fetchTournamentFixturesSuccess({
          fixtures: normalizeFixturesResponse(res),
          tournamentId,
          viewMode: mode,
        }),
      );
    } else {
      yield put(
        fetchTournamentFixturesFailure(
          res.message || "Unable to load tournament fixtures",
        ),
      );
    }
  } catch (error) {
    yield put(fetchTournamentFixturesFailure(error.message));
  }
}

function* onFetchUserFixtures() {
  yield takeLatest(
    fixturesActionTypes.FETCH_USER_FIXTURES_START,
    fetchUserFixtures,
  );
}

function* onFetchAllFixtures() {
  yield takeLatest(
    fixturesActionTypes.FETCH_ALL_FIXTURES_START,
    fetchAllFixtures,
  );
}

function* onFetchCreatorFixtures() {
  yield takeLatest(
    fixturesActionTypes.FETCH_CREATOR_FIXTURES_START,
    fetchCreatorFixtures,
  );
}

function* onFetchTournamentFixtures() {
  yield takeLatest(
    fixturesActionTypes.FETCH_TOURNAMENT_FIXTURES_START,
    fetchTournamentFixtures,
  );
}

export function* fixturesSagas() {
  yield all([
    call(onFetchAllFixtures),
    call(onFetchUserFixtures),
    call(onFetchCreatorFixtures),
    call(onFetchTournamentFixtures),
  ]);
}
